var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion } from '../BaseComponents/Accordion';
import styled from 'styled-components';
var Row = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  padding-top: 12px;\n\n  &:first-child {\n    padding-top: 0;\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  padding-top: 12px;\n\n  &:first-child {\n    padding-top: 0;\n  }\n"])));
function getTextFromFeeDetails(fee) {
    if (!fee) {
        return null;
    }
    return "".concat(fee.amount, " ").concat(fee.currency);
}
export function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
export var RateAccordion = function (_a) {
    var _b;
    var exchangeInfo = _a.exchangeInfo, toggleAccordion = _a.toggleAccordion;
    if (!exchangeInfo.fee || !exchangeInfo.rate) {
        return null;
    }
    var feeDetails = (_b = exchangeInfo.fee) === null || _b === void 0 ? void 0 : _b.details;
    return (_jsxs(Accordion, __assign({ label: "Fees: ".concat(exchangeInfo.totalFeeString), onClick: toggleAccordion }, { children: [_jsxs(Row, { children: [_jsx("div", { children: "Rate updates" }), _jsx("div", { children: exchangeInfo.rateString })] }), feeDetails &&
                feeDetails.map(function (item) { return (_jsxs(Row, { children: [_jsx("div", { children: capitalizeFirstLetter(item.provider) }), _jsx("div", { children: getTextFromFeeDetails(item) })] }, item.provider)); })] })));
};
var templateObject_1;
